import * as React from "react";
import { Context } from "./_context";
export const CollapseCenteredIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.37 9.225a1 1 0 0 1 1.337.068l5 5-1.414 1.414L12 11.414l-4.293 4.293-1.414-1.414 5-5 .076-.068Z", fill: "currentColor" }));
  return iconset[size];
};
CollapseCenteredIcon.iconId = "CX8ieX";
